<div id="builder">
  <div class="coverpage">
    <div fxlayout="row" fxlayoutAlign="space-around center">
      <img src="../../../assets/cover-page1.jpg" alt="cover page1" width="100%">
      <br>
      <img src="../../../assets/logo - Copy.png" alt="chapwoodimage" class="chapwoodlogo">
      <br>
      <br>
      <div>
        <h2 style="font-size: 26px;font-weight: bold;text-align: center;" *ngIf="calculationService.page != 'analysis'">
          Portfolio Builder</h2>
        <h2 style="font-size: 26px;font-weight: bold;text-align: center;" *ngIf="calculationService.page == 'analysis'">
          Portfolio Analysis</h2>
        <!-- <h2 style="font-size: 26px;font-weight: bold;text-align: center;">{{this.model.customerName}}</h2>
        <h2 style="font-size: 26px;font-weight: bold;text-align: center;">{{this.Formatdate}}</h2> -->
        <h2 style="font-size: 26px;font-weight: bold;text-align: center;">Test</h2>
        <h2 style="font-size: 26px;font-weight: bold;text-align: center;">11-27-97</h2>
      </div>
      <div style="text-align: center;font-size: 20px;">
        <p>Ed Butowsky</p>
        <p>Chapwood Investments, LLC</p>
        <p>4965 Preston Park Boulevard, Suite 100</p>
        <p>Plano. TX 75093</p>
      </div>
      <br>
      <img src="../../../assets/cover-page2.png" alt="cover page2" width="100%">
    </div>
  </div>

  <div class="objectiveportfolio">
    <h1 style="text-align: center;color:#244768;font-weight:bold !important;">
      How to Evaluate Your Portfolio
    </h1>

    <div id="blurb1">
      <br>
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Rate of Return</td>
          <td width="50%" class="table-text">This is the rate you need to make on your portfolio in order to
            not lose purchasing power after subtracting your expenses, taxes, and cost of living increase.
          </td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Standard Deviation</td>
          <td width="50%" class="table-text">This is a statistic that measures how much risk you are taking
            versus your return. The lower the number, the better.</td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Variance Drag Phantom Tax</td>
          <td width="50%" class="table-text">This ratio calculates the degree of your standard deviation in
            proportion to your rate of return. Ideally, it will be at 0.8 or less. Anything over 1.5 is not
            acceptable.</td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Sharpe Ratio</td>
          <td width="50%" class="table-text">You want this to be 1 or higher on your entire portfolio.
            Anything at 0.5 or less is unacceptable.</td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Probability of <u>Any</u> Loss in the Next 12 Months</td>
          <td width="50%" class="table-text">This is the probability that your portfolio will experience
            <strong>any</strong> loss during the next 12 months. It should be 15% or less.
          </td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Amount of Money at Risk in the Next 12 Months</td>
          <td width="50%" class="table-text">Based on historical data, this identifies how much money is at
            risk.</td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Upper and Lower Return</td>
          <td width="50%" class="table-text">You want this range of returns to be as narrow as possible.</td>
        </tr>
      </table>
    </div>

    <div id="blurb1">
      <table width="100%">
        <tr>
          <td width="50%" class="table-title">Correlation to S&P 500</td>
          <td width="50%" class="table-text">This shows the movement of one investment or index in relation to
            another. The scale is between +1 and -1.</td>
        </tr>
      </table>
    </div>
  </div>

  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Allocation Pie Chart-->
      <div>
        <h1 class="title">Portfolio Composition</h1>
        <div id="pieChart">
          <apx-chart [series]="pieChartOptions.series" [chart]="pieChartOptions.chart" [colors]="pieChartOptions.colors"
            [dataLabels]="pieChartOptions.dataLabels" [labels]="pieChartOptions.labels"
            [tooltip]="pieChartOptions.tooltip" [responsive]="pieChartOptions.responsive"
            [title]="pieChartOptions.title" [legend]="pieChartOptions.legend">
          </apx-chart>
        </div>
      </div>
      <!-- End of Allocation Pie Chart-->
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Eight Metrics Table-->
      <div class="table result-table">
        <h1 class="title1">Portfolio Statistics</h1>
        <table mat-table *ngIf="statisticDataSource" [dataSource]="statisticDataSource" class="mat-elevation-z2">
          <ng-container matColumnDef="metric">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Portfolio Metric </th>
            <td mat-cell *matCellDef="let statistic"> {{statistic.metric}} </td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Value </th>
            <td mat-cell *matCellDef="let statistic"> {{statistic.value}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="statisticDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: statisticDisplayedColumns;"></tr>
        </table>
      </div>
      <!-- End of Eight Metrics Table-->
    </div>
  </div>

  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Portfolio Breakdown Table-->
      <div class="table">
        <h1 class="title1">Portfolio Breakdown</h1>
        <table mat-table matTableResponsive *ngIf="breakdownDataSource" [dataSource]="breakdownDataSource"
          #breakdownOuterSort="matSort" matSort multiTemplateDataRows class="mat-elevation-z2">
          <ng-container matColumnDef="category_name">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Category </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_name}}
            </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"> Total </td>
          </ng-container>
          <ng-container matColumnDef="category_ticker">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"></th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell"></td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"></td>
          </ng-container>
          <ng-container matColumnDef="category_rate_of_return">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Return </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_rate_of_return | percent:'1.0-2'}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"> {{portfolioBreakdown.portfolio_rate_of_return |
              percent:'1.0-2'}} </td>
          </ng-container>
          <ng-container matColumnDef="category_standard_deviation">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Risk </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_standard_deviation | percent:'1.0-2'}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell">
              {{portfolioBreakdown.portfolio_standard_deviation
              | percent:'1.0-2'}} </td>
          </ng-container>
          <ng-container matColumnDef="category_correlation">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> S&P </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_correlation | number:'1.0-2'}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"> {{portfolioBreakdown.portfolio_correlation |
              number:'1.0-2'}} </td>
          </ng-container>
          <ng-container matColumnDef="category_value">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Value </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_value | currency:'USD':'symbol-narrow':'1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"> {{portfolioBreakdown.portfolio_value |
              currency:'USD':'symbol-narrow':'1.0-0'}} </td>
          </ng-container>
          <ng-container matColumnDef="category_percentage">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> % </th>
            <td mat-cell *matCellDef="let categoryBreakdown" class="category-cell">
              {{categoryBreakdown.category_percentage | percent:'1.0-2'}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-cell"> {{portfolioBreakdown.portfolio_percentage |
              percent:'1.0-2'}} </td>
          </ng-container>
          <ng-container matColumnDef="expandedBreakdownDetail">
            <td mat-cell *matCellDef="let categoryBreakdown" [attr.colspan]="categoryBreakdownColumnsToDisplay.length">
              <div class="category-detail" *ngIf="categoryBreakdown.assetBreakdowns?.data.length"
                [@detailExpand]="categoryBreakdown.isExpanded ? 'expanded' : 'collapsed'">
                <div class="inner-table mat-elevation-z8">
                  <table #breakdownInnerTables mat-table #breakdownInnerSort="matSort"
                    [dataSource]="categoryBreakdown.assetBreakdowns" matSort>
                    <ng-container matColumnDef="asset_name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset </th>
                      <td mat-cell *matCellDef="let assetBreakdown"> {{assetBreakdown.asset_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="asset_ticker">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Ticker </th>
                      <td mat-cell *matCellDef="let assetBreakdown"> {{assetBreakdown.asset_ticker}} </td>
                    </ng-container>
                    <ng-container matColumnDef="asset_rate_of_return">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Return </th>
                      <td mat-cell *matCellDef="let assetBreakdown">
                        {{assetBreakdown.asset_rate_of_return | percent:'1.0-2'}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="asset_standard_deviation">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Risk </th>
                      <td mat-cell *matCellDef="let assetBreakdown">
                        {{assetBreakdown.asset_standard_deviation | percent:'1.0-2'}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="asset_correlation">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> S&P </th>
                      <td mat-cell *matCellDef="let assetBreakdown"> {{assetBreakdown.asset_correlation |
                        number:'1.0-2'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="asset_value">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
                      <td mat-cell *matCellDef="let assetBreakdown">
                        {{assetBreakdown.asset_value | currency:'USD':'symbol-narrow':'1.0-0'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="asset_percentage">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> % </th>
                      <td mat-cell *matCellDef="let assetBreakdown">
                        {{assetBreakdown.asset_percentage | percent:'1.0-2'}}
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="assetBreakdownColumnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let row; columns: assetBreakdownColumnsToDisplay;"></tr>
                  </table>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="categoryBreakdownColumnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let categoryBreakdown; columns: categoryBreakdownColumnsToDisplay;"
            [class.category-row]="categoryBreakdown.assetBreakdowns?.data.length"
            [class.category-expanded-row]="expandedCategoryBreakdown === categoryBreakdown"
            (click)="categoryBreakdown.isExpanded = !categoryBreakdown.isExpanded">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedBreakdownDetail']" class="category-detail-row"></tr>
          <tr mat-footer-row *matFooterRowDef="categoryBreakdownColumnsToDisplay"></tr>
        </table>
      </div>
      <!-- End of Portfolio Breakdown Table-->
    </div>
  </div>

  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Correlation Matrix -->
      <div>
        <h1 class="title1">Correlation Matrix</h1>
        <div id="heatMapChart">
          <apx-chart [series]="heatMapChartOptions.series" [chart]="heatMapChartOptions.chart"
            [dataLabels]="heatMapChartOptions.dataLabels" [plotOptions]="heatMapChartOptions.plotOptions"
            [colors]="heatMapChartOptions.colors" [xaxis]="heatMapChartOptions.xaxis"
            [yaxis]="heatMapChartOptions.yaxis" [title]="heatMapChartOptions.title"></apx-chart>
        </div>
      </div>
      <!-- End of Correlation Matrix -->
    </div>
  </div>

  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Monthly Return Histogram-->
      <div>
        <h1 class="title1">Monthly Returns Histogram</h1>
        <div id="columnChart">
          <apx-chart [series]="columnChartOptions.series" [chart]="columnChartOptions.chart"
            [dataLabels]="columnChartOptions.dataLabels" [plotOptions]="columnChartOptions.plotOptions"
            [colors]="columnChartOptions.colors" [yaxis]="columnChartOptions.yaxis" [legend]="columnChartOptions.legend"
            [fill]="columnChartOptions.fill" [stroke]="columnChartOptions.stroke" [tooltip]="columnChartOptions.tooltip"
            [xaxis]="columnChartOptions.xaxis" [grid]="columnChartOptions.grid" [title]="columnChartOptions.title">
          </apx-chart>
        </div>
      </div>
      <!-- End of Monthly Return Histogram-->
    </div>
  </div>
  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Risk vs Return Bubble Chart -->
      <div>
        <h1 class="title1">Annualized Risk vs Return</h1>
        <div id="bubbleChart">
          <apx-chart [series]="bubbleChartOptions.series" [chart]="bubbleChartOptions.chart"
            [colors]="bubbleChartOptions.colors" [xaxis]="bubbleChartOptions.xaxis" [fill]="bubbleChartOptions.fill"
            [dataLabels]="bubbleChartOptions.dataLabels" [plotOptions]="bubbleChartOptions.plotOptions"
            [title]="bubbleChartOptions.title" [yaxis]="bubbleChartOptions.yaxis" [grid]="bubbleChartOptions.grid">
          </apx-chart>
        </div>
      </div>
      <!-- End of Risk vs Return Bubble Chart -->
    </div>
  </div>

  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- Rate of Return Charts -->
      <div>
        <h1 class="title1">Historical Rate of Return</h1>
        <div id="rorChart">
          <apx-chart [series]="rorChartOptions.series" [chart]="rorChartOptions.chart"
            [dataLabels]="rorChartOptions.dataLabels" [plotOptions]="rorChartOptions.plotOptions"
            [xaxis]="rorChartOptions.xaxis" [yaxis]="rorChartOptions.yaxis" [title]="rorChartOptions.title">
          </apx-chart>
        </div>
      </div>
      <!-- Rate of Return Charts -->
    </div>
  </div>
  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <!-- 10 Year Chart -->
      <div>
        <h1 class="title1">Ten Year Returns</h1>
        <div id="rorChart">
          <apx-chart [series]="tenYearChartOptions.series" [chart]="tenYearChartOptions.chart"
            [xaxis]="tenYearChartOptions.xaxis" [yaxis]="tenYearChartOptions.yaxis"
            [dataLabels]="tenYearChartOptions.dataLabels" [grid]="tenYearChartOptions.grid"
            [stroke]="tenYearChartOptions.stroke" [tooltip]="tenYearChartOptions.tooltip"
            [title]="tenYearChartOptions.title" [legend]="tenYearChartOptions.legend"
            [markers]="tenYearChartOptions.markers" [colors]="tenYearChartOptions.colors"
            [responsive]="tenYearChartOptions.responsive"></apx-chart>
        </div>
      </div>
      <!-- End of 10 Year Chart -->
    </div>
  </div>
  <!-- 10 year Table -->
  <div class="section">
    <div fxLayout="row" fxLayoutAlign="center center">
      <div class="table result-table">
        <h1 class="title1">Ten Year Values</h1>
        <table mat-table *ngIf="tenYearDataSource" [dataSource]="tenYearDataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Year </th>
            <td mat-cell *matCellDef="let point"> {{point.year}} </td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="primary-bg"> Value </th>
            <td mat-cell *matCellDef="let point"> {{point.value |
              currency:'USD':'symbol-narrow':'1.0-0'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="tenYearDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tenYearDisplayedColumns;"></tr>
        </table>
      </div>
      <!-- End of 10 Year Table-->
    </div>
  </div>
</div>